import { useAppContext } from '../../appProvider/contextProvider';
import { ERRORS } from '../../constants/AppConstants';

const SuspendedBar = () => {
    const {setPricingPopupOpen, selectedWebsite} = useAppContext();

    const getSuspensionReason = () => {
        if(selectedWebsite?.suspension_reason.length) {
            return ERRORS[selectedWebsite?.suspension_reason[0]];
        }
        return ERRORS.subscription_cancelled;
    }
    return <div className="sus-banner" >
        {getSuspensionReason()}
        <span onClick={() =>setPricingPopupOpen(true)} className="upgrade-text ml-2">Upgrade Now!</span>
    </div>
}

export default SuspendedBar;